import {CollectionPropertyFilter} from "../data-table.component";

export type FilterOption = {
    Name: string;
    FilterClauseFormat: string;
    IsExactMatchFilter?: boolean;
}

export class FilterSettings {
    private FilterClauseFormat: string;
    public FilterModel: any;
    
    constructor(filterClauseFormat: string, filterModel: any) {
        this.FilterClauseFormat = filterClauseFormat;
        this.FilterModel = filterModel;
    }
    
    public GetFilter(...propertyNames: (CollectionPropertyFilter|string)[]) {
        return propertyNames.map(p =>
            '(' +
            (typeof p === 'string'
                ? FilterUtils.format(this.FilterClauseFormat, p)
                : this.GetCollectionFilterClause(p)) + 
            ')').join(' or ');
    }
    
    private GetCollectionFilterClause(filter: CollectionPropertyFilter) {
        return filter.CollectionPropertyName +
            '/any(p:' +
            FilterUtils.format(
                this.FilterClauseFormat,
                'p' + (filter.FilterPropertyName ? '/' + filter.FilterPropertyName : '')) +
            ')';
    }
}

export class FilterUtils {
    // Utterly insane that javascript doesn't support this natively
    public static format(format: string, ...values: any[]): string {
        return format.replace(/\{(\d+)}/g, function(match: string, index: string) {
            return values[+index];
        });
    }
    
    public static buildListFilterOptions(enumSet: any, displayValues: Record<any, string>) {
        let enumKeys = Object.keys(enumSet).filter(e => isNaN(parseInt(e)));
        return enumKeys.map(e => ({
            Text: displayValues[e],
            Value: e,
        }))
    }
}